<template>
<div class="item flex rcs" @click="selectItem" :class="{selected: item.selected}">
    <template v-if="type == Constants.USER_STUDENT">
        <van-checkbox v-model="item.selected" v-if="isShowCheckBox"></van-checkbox>
        <div class="line-style ver-line title-line" v-if="isShowCheckBox"></div>
        <div class="item-con-wrap flex-1">
            <div>
                <p class="title">{{item.name}}</p>
                <div class="type" :class="{type1: item.sign_status.status === 1, type2: item.sign_status.status === 0, type3: (item.sign_status.status === -1 || item.sign_status.status === -2)}">{{item.sign_status.status_text}}</div>
            </div>
            <div>
                <p class="price">座位费￥<span>{{item.seat_fee}}</span></p>
                <span>{{item.enroll_num}}人报名</span>
            </div>
            <p>上课时间：{{item.start_time}}</p>
        </div>
    </template>

    <template v-if="type == Constants.USER_WORKER">
        <van-checkbox v-model="item.selected" v-if="isShowCheckBox"></van-checkbox>
        <div class="line-style ver-line title-line" v-if="isShowCheckBox"></div>
        <div class="item-con-wrap flex-1">
            <div>
                <p class="title">{{item.name}}</p>
                <div class="type" :class="{type2: item.sign_status.status === 1, type3: item.sign_status.status === 0}">{{item.sign_status.status_text}}</div>
            </div>
            <div class="radio-wrap none">
                <div class="radio-box none" @click.stop>
                    <van-radio-group v-model="item.job" direction="horizontal" :disabled="item.sign_status.status === 0">
                        <van-radio :name="Constants.WORKER_LEADER">桌长</van-radio>
                        <van-radio :name="Constants.WORKER_GROUP">外围</van-radio>
                    </van-radio-group>
                </div>
                <span>{{item.enroll_num}}人报名</span>
            </div>
            <p class="flex rcb">
                <span class="title">上课时间：{{item.start_time}}</span>
                <span class="detail">{{item.enroll_num}}人报名</span>
            </p>
        </div>
    </template>
</div>
</template>

<script>
export default {
    name: "courseDetailEnrollItem",
    props: ['item', 'index', 'type'],
    computed: {
        isShowCheckBox() {
            let status = false;
            if(this.type == this.Constants.USER_STUDENT) {
                status = 1 > this.item.sign_status.status && this.item.sign_status.status > -1;
            } else {
                status = 2 > this.item.sign_status.status && this.item.sign_status.status > 0;
            }

            return status;
        }
    },
    data() {
        return {};
    },
    methods: {
        selectItem() {
            this.$emit('callback', this.index);
        },
    }
};
</script>

<style lang="less" scoped>
.item {
    margin: 10px 15px;
    padding: 10px;
    background: #fff;
    box-sizing: border-box;
    border: solid #fff 1px;
    border-radius: 3px;

    .title-line {
        height: 6rem;
        margin: 0 1.5rem;
    }

    .item-con-wrap {

        >div {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            >.title {
                flex: 1;
                font-size: 15px;
                color: #333;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            >.type {
                padding: 0 8px;
                height: 21px;
                border-radius: 3px;
                font-size: 12px;
                white-space: nowrap;
                line-height: 1;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            >.type1 {
                background: linear-gradient(217deg, #9cb2f4 14%, #6472e8 84%);
                color: #fff;
            }

            >.type2 {
                height: 19px;
                border: 1px solid #7181EB;
                color: #7181EB;
                background: #F1F3FF;
            }

            >.type3 {
                border: 1px solid #999;
                color: #999;
                background: #F5F5F5;
            }

            >.price {
                flex: 1;
                font-size: 13px;
                color: #F83535;

                span {
                    font-size: 18px;
                    font-weight: 500;
                }
            }

            .radio-box {}

            >span {
                font-size: 15px;
                color: #7181EB;
            }
        }

        >p {
            font-size: 13px;
            color: #333;
            .detail {
                color: #7181EB;
                font-size: 16px;
                font-weight: 500;
            }
        }
    }
}

.selected {
    border: solid #399cf8 1px;
    background-color: rgba(248, 251, 255, 1);
}
</style>
